import React, { useState, useMemo, useEffect, useRef, ReactNode } from 'react';
import { useSetRecoilState, useRecoilValue, useRecoilState } from 'recoil';
import {
  errorModalTextRecoil,
  completeModalRecoil,
  entryDailyDetailModalRecoil,
} from '@/atom/ModalAtom';
import {
  entryDetailListRecoil,
  entryDetailListLengthRecoil,
  entryCertiIdRecoil,
  entryNameRecoil,
  entryPhoneRecoil,
  entryPlaceIdRecoil,
  entryStartDateRecoil,
  entryEndDateRecoil,
} from '@/atom/EntryAtom';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import LS from '@/styles/layoutStyled';
import CS from '@/styles/componentStyled';
import BS from '@/styles/btnStyled';
import IS from '@/styles/inputStyled';
import { ApiService } from '@/api';
import Pagenation from '@/component/Pagenation';
import ModalType1 from '@/modal/ModalType1';
import { EntryDto, EntrySearchDto } from '@/model/entry.dto';
import ExcelDownloadButton from '@/component/ExcelDownloadButton';

const EntryDailyDetailModal = () => {
  const api = useMemo(() => new ApiService(), []);
  const navigate = useNavigate();

  const setErrorModalText = useSetRecoilState(errorModalTextRecoil);
  const setCompleteModalState = useSetRecoilState(completeModalRecoil);
  const setEntryDailyDetailModalState = useSetRecoilState(
    entryDailyDetailModalRecoil,
  );
  const [entryDetailListState, setEntryDetailListState] = useRecoilState(
    entryDetailListRecoil,
  );
  const [entryDetailListLengthState, setEntryDetailListLengthState] =
    useRecoilState(entryDetailListLengthRecoil);
  const [entryCertiIdState, setEntryCertiIdState] =
    useRecoilState(entryCertiIdRecoil);
  const [entryNameState, setEntryNameState] = useRecoilState(entryNameRecoil);
  const [entryPhoneState, setEntryPhoneState] =
    useRecoilState(entryPhoneRecoil);
  const [entryPlaceIdState, setEntryPlaceIdState] =
    useRecoilState(entryPlaceIdRecoil);
  const [entryStartDateState, setEntryStartDateState] =
    useRecoilState(entryStartDateRecoil);
  const [entryEndDateState, setEntryEndDateState] =
    useRecoilState(entryEndDateRecoil);

  const [entryDetailAllList, setEntryDetailAllList] = useState<EntryDto[]>([]);
  const [offset, setOffset] = useState<number>(0);
  const [limit, setLimit] = useState<number>(10);

  const fetchEntryDetailList = async () => {
    try {
      const dto: EntrySearchDto = {
        certi_id: entryCertiIdState === null ? '' : entryCertiIdState,
        name: entryNameState === null ? '' : entryNameState,
        phone: entryPhoneState === null ? '' : entryPhoneState,
        place_id: entryPlaceIdState === null ? '' : entryPlaceIdState,
        start_date: entryStartDateState === null ? '' : entryStartDateState,
        end_date: entryEndDateState === null ? '' : entryEndDateState,
      };
      const response: EntryDto[] = await api.getEntryDetailList(
        String(sessionStorage.getItem('accessToken')),
        dto,
      );
      setEntryDetailAllList(response);
      setEntryDetailListLengthState(response.length);
    } catch (err: any) {
      if (err.response.data.statusCode === 401) {
        sessionStorage.clear();
        navigate('/login');
      }
    }
  };

  const filterEntryDetailList = async () => {
    const dto: EntrySearchDto = {
      certi_id: entryCertiIdState === null ? '' : entryCertiIdState,
      name: entryNameState === null ? '' : entryNameState,
      phone: entryPhoneState === null ? '' : entryPhoneState,
      place_id: entryPlaceIdState === null ? '' : entryPlaceIdState,
      start_date: entryStartDateState === null ? '' : entryStartDateState,
      end_date: entryEndDateState === null ? '' : entryEndDateState,
      offset,
      limit,
    };
    try {
      const response: EntryDto[] = await api.getEntryDetailList(
        String(sessionStorage.getItem('accessToken')),
        dto,
      );
      setEntryDetailListState(response);
    } catch (err: any) {
      if (err.response.data.statusCode === 401) {
        sessionStorage.clear();
        navigate('/login');
      }
    }
  };

  const handleOffsetChange = (value: number) => {
    setOffset((value - 1) * limit);
  };
  const handleModalClose = () => {
    setEntryDailyDetailModalState(false);
    setOffset(0);
  };

  useEffect(() => {
    fetchEntryDetailList();
    filterEntryDetailList();
  }, [offset]);

  return (
    <>
      <ModalType1>
        <div className="title-box flex aic jcsb">
          <h1>출입 상세 현황</h1>
          <button className="x-btn img-box" onClick={handleModalClose}>
            <img src="./img/ico_x_444.svg" alt="" />
          </button>
        </div>
        <div className="cnt-wrap">
          <BtnWrap>
            <ExcelDownloadButton
              headers={[
                { label: '이름', key: 'applicant' },
                { label: '핸드폰 번호', key: 'phone' },
                { label: '출입장소', key: 'place_name' },
                { label: '출입증 번호', key: 'certi_id' },
                { label: '출입 시간', key: 'entry_time' },
              ]}
              data={entryDetailAllList}
              fileName="출입 관리 상세"
              sheetName="출입 관리 상세"
            />
          </BtnWrap>
          <TableBox>
            <table>
              <thead>
                <tr>
                  <th>이름</th>
                  <th>핸드폰 번호</th>
                  <th>출입장소</th>
                  <th>출입증 번호</th>
                  <th>출입 날짜</th>
                  <th>출입 시각</th>
                </tr>
              </thead>
              <tbody>
                {entryDetailListState?.map((list, index) => (
                  <tr key={index}>
                    <td>{list.applicant}</td>
                    <td>{list.phone}</td>
                    <td>{list.place_name}</td>
                    <td>{list.certi_id}</td>
                    <td>{list.entry_time?.split(' ')[0]}</td>
                    <td>{list.entry_time?.split(' ')[1].slice(0, 8)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </TableBox>
          <Pagenation
            listAllLength={entryDetailListLengthState}
            listLimit={limit}
            onCurrentPageChange={handleOffsetChange}
          />
          <div className="btn-wrap">
            <BS.Btn2Type3 type="button" onClick={handleModalClose}>
              닫기
            </BS.Btn2Type3>
          </div>
        </div>
      </ModalType1>
    </>
  );
};

export default EntryDailyDetailModal;

export const TableBox = styled(CS.TableType1Mini)`
  margin-bottom: 12px;
`;

export const BtnWrap = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: 12px;
`;
